export interface OrderCommand {
  comment?: string;
  nextBoxDate: Date;
}
